import React from 'react';
import toLower from 'lodash/toLower';
import toUpper from 'lodash/toUpper';
import { Tag } from 'antd';

export default function Status({ children, props, masterStatusName }) {
  const status = toLower(children);
  const style = { width: '75%', textAlign: 'center' };

  switch (toLower(masterStatusName)) {
    case 'unallocated':
      return <Tag style={style} color='red'>{toUpper(status)}</Tag>;
    case 'pending':
      return <Tag style={style} color='gold'>{toUpper(status)}</Tag>;
    case 'allocated':
      return <Tag style={style} color='green'>{toUpper(status)}</Tag>;
    case 'awaiting_pickup':
      return <Tag style={style} color='green'>{toUpper(status)}</Tag>;
    case 'being_collected':
      return <Tag style={style} color='green'>{toUpper(status)}</Tag>;
    case 'transport_to_garage':
      return <Tag style={style} color='green'>{toUpper(status)}</Tag>;
    case 'at_garage':
      return <Tag style={style} color='gold'>{toUpper(status)}</Tag>;
    case 'quoting_extra_work':
      return <Tag style={style} color='gold'>{toUpper(status)}</Tag>;
    case 'to_review':
      return <Tag style={style} color='gold'>{toUpper(status)}</Tag>;
    case 'customer_reviewing':
      return <Tag style={style} color='gold'>{toUpper(status)}</Tag>;
    case 'customer_reviewed':
      return <Tag style={style} color='magenta'>{toUpper(status)}</Tag>;
    case 'work_complete':
      return <Tag style={style} color='red'>{toUpper(status)}</Tag>;
    case 'paid':
      return <Tag style={style} color='gold'>{toUpper(status)}</Tag>;
    case 'being_returned':
      return <Tag style={style} color='green'>{toUpper(status)}</Tag>;
    case 'garage_declined':
      return <Tag style={style} color='magenta'>{toUpper(status)}</Tag>;
    case 'time_changes':
      return <Tag style={style} color='magenta'>{toUpper(status)}</Tag>;
    default:
      return <Tag style={style}>{toUpper(status)}</Tag>;
  }
}
